import Model from './Model';

export default class Employee extends Model {
    resource() {
        return 'employees';
    }
}
